module.exports = __webpack_public_path__ + "static/media/chart-background.b5821c89.svg";